module.exports = __webpack_public_path__ + "static/media/trial3_2.51994477.png";